import React from "react";
import { Trophy } from "lucide-react";

const PLACES = [
  { rank: 2, h: "h-24", delay: "0.5s", label: "2e" },
  { rank: 1, h: "h-36", delay: "1.1s", label: "1er" },
  { rank: 3, h: "h-16", delay: "0.2s", label: "3e" },
];

const CONFETTI = Array.from({ length: 26 }, (_, i) => ({ left: `${(i * 37) % 100}%`, delay: `${(i % 9) * 0.35}s`, dur: `${3.2 + (i % 5) * 0.5}s`, size: 4 + (i % 3) * 2 }));

export function Podium({ board = [], message, myId, testid = "podium" }) {
  const top = [board[1], board[0], board[2]];
  return (
    <div className="relative overflow-hidden py-6" data-testid={testid}>
      <style>{`@keyframes mya-rise{from{transform:translateY(40px);opacity:0}to{transform:none;opacity:1}}
@keyframes mya-fall{0%{transform:translateY(-20px) rotate(0);opacity:0}10%{opacity:1}100%{transform:translateY(520px) rotate(540deg);opacity:0}}
@keyframes mya-glow{0%,100%{box-shadow:0 0 0 rgba(220,180,87,0)}50%{box-shadow:0 0 38px rgba(220,180,87,.45)}}`}</style>
      {CONFETTI.map((c, i) => <span key={i} aria-hidden className="absolute top-0 bg-[#DCB457]" style={{ left: c.left, width: c.size, height: c.size * 1.6, animation: `mya-fall ${c.dur} ${c.delay} linear infinite`, opacity: 0 }} />)}
      <p className="text-center text-[10px] uppercase tracking-[0.35em] text-[#DCB457] relative">Podium final</p>
      <div className="flex items-end justify-center gap-2 mt-6 relative">
        {PLACES.map((p, i) => {
          const t = top[i];
          return (
            <div key={p.rank} className="flex-1 max-w-[140px] flex flex-col items-center" style={{ animation: `mya-rise .8s ${p.delay} both cubic-bezier(.2,.8,.2,1)` }} data-testid={`${testid}-${p.rank}`}>
              {p.rank === 1 && <Trophy className="text-[#DCB457] mb-2" size={30} />}
              <p className={`text-center text-sm leading-tight px-1 ${t?.id === myId ? "text-[#DCB457]" : "text-white"}`}>{t ? t.name : "—"}</p>
              {t && board.some((b) => b.id !== t.id && b.rank === t.rank) && <p className="text-[9px] uppercase tracking-[0.16em] text-[#DCB457]">ex æquo</p>}
              {t && <p className="text-[11px] text-white/55 mt-1">{t.score} pt{t.score > 1 ? "s" : ""}{t.good != null ? ` · ${t.good} bonne${t.good > 1 ? "s" : ""} rép.` : ""}</p>}
              <div className={`w-full ${p.h} mt-2 border border-[#DCB457]/50 bg-gradient-to-b from-[#DCB457]/25 to-transparent flex items-start justify-center pt-2`} style={p.rank === 1 ? { animation: "mya-glow 2.4s 1.8s ease-in-out infinite" } : undefined}>
                <span className="font-serif-luxe text-2xl text-[#DCB457]">{t?.rank && t.rank !== p.rank ? (t.rank === 1 ? "1er" : `${t.rank}e`) : p.label}</span>
              </div>
            </div>
          );
        })}
      </div>
      {message && <p className="font-serif-luxe italic text-xl text-center mt-8 px-4 leading-snug relative" style={{ animation: "mya-rise 1s 1.8s both" }} data-testid={`${testid}-message`}>{message}</p>}
    </div>
  );
}

export const RehearsalBanner = () => (
  <div className="bg-amber-400 text-black text-center text-[11px] font-semibold uppercase tracking-[0.12em] px-3 py-2" data-testid="rehearsal-banner">
    Mode répétition — Aucune réponse ne sera enregistrée dans la partie réelle
  </div>
);
